import { render } from "./InfoImage.vue?vue&type=template&id=2c9f0418"
import script from "./InfoImage.vue?vue&type=script&lang=js"
export * from "./InfoImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__